import { HubConnectionBuilder, LogLevel, HubConnectionState } from '@microsoft/signalr';
import { API_BASE_URL } from '../config/api';

class WebSocketService {
    constructor() {
        this.connection = null;
        this.listeners = {};
        this.reconnectInterval = 5000;
    }

    // Initialize and connect
    async connect() {
        if (this.connection && this.connection.state === HubConnectionState.Connected) {
            console.log('SignalR: Already connected');
            return;
        }

        const hubUrl = `${API_BASE_URL}/hubs/notifications`;

        console.log('SignalR: Connecting to', hubUrl);

        this.connection = new HubConnectionBuilder()
            .withUrl(hubUrl)
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Information)
            .build();

        // Register handlers
        this.connection.onclose((error) => {
            console.warn('SignalR: Connection closed', error);
        });

        this.connection.onreconnecting((error) => {
            console.log('SignalR: Reconnecting...', error);
        });

        this.connection.onreconnected((connectionId) => {
            console.log('SignalR: Reconnected', connectionId);
        });

        // Listen to "UserUpdated" from backend
        this.connection.on('UserUpdated', (userId) => {
            console.log('SignalR: Received UserUpdated for ID', userId);
            this.trigger('UserUpdated', userId);
        });

        try {
            await this.connection.start();
            console.log('SignalR: Connected successfully');
        } catch (error) {
            console.error('SignalR: Connection failed', error);
        }
    }

    // Subscribe to events
    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    }

    // Unsubscribe
    off(event, callback) {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }

    // Trigger internal listeners
    trigger(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach(callback => callback(data));
    }

    // Join a specific group
    async joinGroup(groupName) {
        if (!this.connection || this.connection.state !== HubConnectionState.Connected) return;
        try {
            await this.connection.invoke('JoinGroup', groupName);
            console.log('SignalR: Joined group', groupName);
        } catch (error) {
            console.error('SignalR: Failed to join group', error);
        }
    }

    async stop() {
        if (this.connection) {
            await this.connection.stop();
            console.log('SignalR: Stopped');
        }
    }
}

export const socketService = new WebSocketService();
